<template>
  <div class="routing-map">
    <div class="map-here" id="mapHere2"></div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import mapSettings from '@/values/map-settings'
import mapPins from '@/values/map-pin'
import featureToggle from '@/modules/api/featureToggle'

export default {
  name: 'laxit-map',
  data () {
    return {
      hereMaps: {
        map: {},
        platform: {},
        router: {},
        geocoder: {},
        directions: [],
        ui: {}
      },
      mapOptions: mapSettings,
      pickupPin: mapPins.pickup,
      dropoffPin: mapPins.dropoff,
      mapPins: [],
      infoWindows: [],
      route: [],
      routes: [],
      center: { lat: 33.942791, lng: -118.410042 }
    }
  },
  computed: {
    items () { return this.$store.state.laxit.dropzone.items }
  },
  watch: {
    items (value) {
      let self = this

      self.hereMaps.ui.getBubbles().forEach(bub => {
        bub.close()
      })
      self.hereMaps.ui.removeBubble(self.hereMaps.ui.getBubbles())
      self.hereMaps.map.removeObjects(self.hereMaps.map.getObjects())

      if (value.length <= 0) {
        self.route = []
        self.routes = []
        self.mapPins = []
        self.infoWindows = []
        return
      }

      setTimeout(function () {
        self.setMapPins()
      }, 400)
    }
  },
  methods: {
    closeInfoWindow (index) {
      let self = this
      self.infoWindows[index].opened = false
    },
    openInfoWindow (index) {
      let self = this
      self.infoWindows[index].opened = true
    },
    computeEta (pin) {
      let self = this
      let firstStop = self.items[0]
      return moment(firstStop.pickupTime, 'MM/DD/YYYY hh:mmA').add(pin.eta, 'seconds').format('MM/DD/YYYY ' + featureToggle.timeFormat(self, false))
    },
    computeMaxEta (pin) {
      return moment(pin.pickupTime, 'MM/DD/YYYY hh:mmA').add(pin.maxDuration, 'seconds').format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
    },
    computeOriginalBTT (pin) {
      return moment(pin.originalPickupTime, 'MM/DD/YYYY hh:mmA').add(pin.originalBTT, 'seconds').format('MM/DD/YYYY ' + featureToggle.timeFormat(this, false))
    },
    setMapPins () {
      let self = this
      self.mapPins = []
      self.infoWindows = []

      self.items.forEach((item, i) => {
        self.mapPins.push({
          lat: item.location.lat,
          lng: item.location.lng,
          isPickup: item.isPickup,
          reservationID: item.reservationID,
          packageID: item.packageID,
          pickupTime: item.pickupTime,
          originalPickupTime: item.originalPickupTime,
          originalBTT: item.originalBTT,
          eta: item.eta,
          maxDuration: item.maxDuration,
          opened: true
        })
        self.infoWindows.push(self.mapPins[i])

        let content = '<div class="here-info-window-content routing">' +
          '<div class="stop-id"><span class="index {IS_PICKUP}">{INDEX}</span>'+
          '<span>ID: </span><a href="/#/reservation/{RSVP_ID}" target="_blank">{RSVP_ID}</a>' +
          '{IF_PKG}</div>{IF_PICKUP}</div>'
        content = content.replace('{INDEX}', i + 1).split('{RSVP_ID}').join(item.reservationID)
          .replace('{IS_PICKUP}', item.isPickup ? 'pickup' : '')

        let ifPkg = ''
        if (item.packageID !== null) {
          ifPkg = '<a href="/#/package/' + item.packageID + '" target="_blank">' + item.packageID + '</a>'
        }
        content = content.replace('{IF_PKG}', ifPkg)

        let ifPickup = ''
        if (item.isPickup) {
          ifPickup = '<div class="stop-put">PUT: <span class="value">' + item.originalPickupTime + '</span></div>'
        }
        if (i > 0) {
          ifPickup = ifPickup + '<div class="stop-eta">ETA: <span class="value">' + self.computeEta(item) + '</span></div>'
        }
        if (i > 0 && !item.isPickup) {
          ifPickup = ifPickup + '<div class="stop-btt">BTT: <span class="value">' + self.computeOriginalBTT(item) + '</span></div>'
        }
        content = content.replace('{IF_PICKUP}', ifPickup)

        // Pickup/Dropoff icon
        let marker = '<svg height="25" width="25" style="overflow: unset" viewBox="0 0 50 50">' +
          '<path d="{D}" fill="{FILL}"stroke="{STROKE}"' +
          'stroke-width="{STROKE_WIDTH}" /></svg>'

        let pickupDropoff = item.isPickup ? 'pickup' : 'dropoff'

        marker = marker.replace('{D}', mapPins[pickupDropoff].path)
          .replace('{FILL}', mapPins[pickupDropoff].fillColor)
          .replace('{STROKE}', mapPins[pickupDropoff].strokeColor)
          .replace('{STROKE_WIDTH}', mapPins[pickupDropoff].strokeWeight)
        let icon = new window.H.map.DomIcon(marker)
        let coords = {lat: item.location.lat, lng: item.location.lng}
        let pin = new window.H.map.DomMarker(coords, {icon: icon})
        pin.id = 'marker' + i
        pin.lat = item.location.lat
        pin.lng = item.location.lng
        let bubble = new window.H.ui.InfoBubble(coords, {content: content})
        bubble.id = (item.isPickup ? 'pickup' : 'dropoff') + item.reservationID
        self.hereMaps.ui.addBubble(bubble)
        bubble.addEventListener('tap', function (evt) {
          bubble.open()
        }, false)
        self.hereMaps.map.addObject(pin)
      })

      self.setRoute()
    },
    setRoute () {
      let self = this
      // self.setMapPins()
      // self.setCenter()

      self.routes = []
      let duration = 0
      for (let i = 0; i < self.items.length - 1; i++) {
        let leg = self.items[i]
        let nextLeg = self.items[i + 1]

        self.calculateRoute(leg, nextLeg)
      }
    },
    calculateRoute (origin, destination) {
      let self = this
      let router = self.hereMaps.platform.getRoutingService(null, 8)
      let routeRequestParams = {
        routingMode: 'fast',
        transportMode: 'car',
        origin: origin.location.lat + ',' + origin.location.lng,
        destination: destination.location.lat + ',' + destination.location.lng,
        return: 'polyline,turnByTurnActions,actions,instructions,travelSummary'
      }

      router.calculateRoute(
        routeRequestParams,
        self.onCalculateSuccess.bind(null, destination),
        self.onCalculateError
      )
    },
    onCalculateSuccess (nextLeg, result) {
      if (!result.routes.length) return
      var route = result.routes[0].sections[0]
      this.$store.commit('laxit/updateDropzoneEta', {
        leg: nextLeg, eta: route.travelSummary.baseDuration
      })
      this.addRouteShapeToMap(route)
    },
    onCalculateError (data) {
      console.error('ROUTING ERROR', data)
    },
    addRouteShapeToMap (route) {
      // let lineString = new window.H.geo.LineString()
      // let routeShape = route.shape
      // let polyline = ''

      // routeShape.forEach(function (point) {
      //   let parts = point.split(',');
      //   lineString.pushLatLngAlt(parts[0], parts[1]);
      // })

      // polyline = new window.H.map.Polyline(lineString, {
      //   style: {
      //     lineWidth: 4,
      //     strokeColor: 'rgba(25, 25, 25, 0.7)'
      //   }
      // })
      let linestring = window.H.geo.LineString.fromFlexiblePolyline(route.polyline);
      let polyline = new window.H.map.Polyline(linestring, {
        style: {
          lineWidth: 4,
          strokeColor: 'rgba(25, 25, 25, 0.7)'
        }
      });
      polyline.id = 'rsvpRoute'

      this.hereMaps.map.addObject(polyline)
      this.hereMaps.map.getViewModel().setLookAtData({
        bounds: polyline.getBoundingBox()
      })

      this.setCenter()
    },
    setCenter () {
      let self = this
      let group = new window.H.map.Group()
      let circles = []
      for (let object of self.hereMaps.map.getObjects()) {
        if (object.id && object.id.indexOf('marker') > -1) {
          let circle = new window.H.map.Circle(
            new window.H.geo.Point(object.lat, object.lng),
            15000,
            {style: {fillColor: 'rgba(0, 0, 0, 0)', strokeColor: 'rgba(0, 0, 0, 0)'}}
          )
          circles.push(circle)
        }
      }

      group.addObjects(circles)
      group.id = 'groupBound'
      self.hereMaps.map.addObject(group)
      self.hereMaps.map.getViewModel().setLookAtData({
        bounds: group.getBoundingBox()
      })
    }
  },
  mounted () {
    let self = this
    let mapContainer = document.getElementById('mapHere2')
    self.hereMaps.platform = new window.H.service.Platform({apikey: CONFIG.hereApi.key})

    let defaultLayers = self.hereMaps.platform.createDefaultLayers()
    self.hereMaps.map = new window.H.Map(mapContainer,
      defaultLayers.vector.normal.map, {
        center: self.center,
        zoom: 13,
        pixelRatio: window.devicePixelRatio || 1
      }
    )

    /* eslint-disable no-unused-vars */
    let behavior = new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(self.hereMaps.map))
    /* eslint-enable no-unused-vars */
    self.hereMaps.ui = window.H.ui.UI.createDefault(self.hereMaps.map, defaultLayers)
  }
}
</script>

<style lang="scss" scoped>
.routing-map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .routing-map{ display:none; }
}

.map-here{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.stop-info {
  color: #333;
  font-size: 12px;

  & a, & .value {
    font-weight: 700;
  }

  & .value {
    color: #555;
  }

  & .stop-id {
    border-bottom: 1px solid rgba(0,0,0,0.15);
    padding: 0 0 7px 0;
    margin-bottom: 10px;

    & > * {
      display: inline-block;
      vertical-align: middle;
    }
  }

  & .stop-location {
    display: inline-block;
    width: 16px;
    height: 16px;
    line-height: 16px;
    text-align: center;
    border-radius: 100%;
    background-color: #F20D0D;
    margin-right: 5px;
    color: #fff;
    font-weight: 700;

    &.pickup { background-color: #26D97A; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Laxit/Map.vue